module.exports = __webpack_public_path__ + "img/book.4f4e96e4.png";